// extracted by mini-css-extract-plugin
export default {"pokeball":"Pokeball_pokeball__1A-1K","w10":"Pokeball_w10__zqalW"};